import React from 'react'
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import T, { dT } from '../components/Translation';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { _FETCH } from '../utils/patches';
import VisDiv from '../components/VisDiv';
import { goldColour } from './Home';
import { _UPDATEPUBLIC, _UPDATE} from '../utils/patches';
import { errorAlert, successAlert } from '../utils/utils';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';

const Unsubscribe = () => {
    const {apiUrl, language, hideTestButtons} = useStateContext()
    const {user} = useAuthContext(AuthContext)

    const urlParams = new URLSearchParams(window.location.search);
    const campaignId = urlParams.get('campaignId');
    const emailId = urlParams.get('emailId');
    const email = urlParams.get('userEmail');

    const { data: prospectData, isLoading: ProspectDataLoading} = useQuery({
          queryKey: ['prospectData'],
          enabled: !!email,
          queryFn: async () => {
            const response = await fetch(`${apiUrl}/prospects/email/${email}`);
            if (!response.ok) {
                throw new Error('Failed to fetch prospect');
            }
            return response.json();
        }
        });

    const queryClient = useQueryClient();

    const onError = () => {
      console.log("error")
      errorAlert(dT({en: "Error unsubscribing, try again", it: "Si è verificato un errore, riprova"}, language) || "Error unsubscribing, try again")
    }
    const onSuccess = () => {
      console.log("success")
      successAlert(dT({en: "Unsubscribed successfully", it: "Sottoscritto con successo"}, language) || "Unsubscribed successfully")
    }
    const { mutate: unsubscribeProspect } = useMutation({  
    mutationFn: async(doc) => {
      return await _UPDATEPUBLIC({doc: {unsubscribed: true}, route: `${apiUrl}/prospects/public/${prospectData._id}`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['prospectsData'] }),
    mutationKey:['prospectsData'],

  })
  const { mutate: unsubscribeMarketing } = useMutation({  
    mutationFn: async(doc) => {
      return await _UPDATE({doc: {acceptMarketing: false}, user, route: `${apiUrl}/user/patch/update-profile`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['userData'] }),
    mutationKey:['userData'],

  })

    const testFunction = () => {
      console.log("ksandkjdns", {campaignId, user, prospectData, emailId, email})
    }
    const unsubscribe = () => {
      if(prospectData){
        unsubscribeProspect()
      }
      if(user){
        unsubscribeMarketing()
      }
    }
  if(!email) {
    return (
      <p>
        <T obj={{en:"Invalid Link, no email found", it:"Link non valido, nessun indirizzo email trovato"}}/>
      </p>
    )
  }
  if(email && (ProspectDataLoading)) {
    return (
      <Loading/>
    )
  }
  return (
    <div style={{display: "flex", width: "100%", height:"100vh", backgroundColor: goldColour, alignItems: "center", justifyContent: "center", flexDirection: "column"}}> 
      <div style={{backgroundColor:"white",borderRadius:"10px", margin:"20px", padding:"40px", maxWidth:"800px"}}>
          <BlueButton fn={testFunction} hide={hideTestButtons} />
          <VisDiv rules={[user]}>
            <VisDiv style={{marginBottom:"20px"}} rules={[user?.firstName]}>
              <h3>
                <T obj={{en:"Hi", it:"Ciao"}}/>
                {` ${user?.firstName ? user.firstName : email}`}
              </h3>
            </VisDiv> 
            <p><T obj={{
              en:`We are sad to see you go! Since you are a user on our website, 
                we want to let you know that you will still receive important notifications such as legal changes in our policies
                or notifications related on your services. 
                `,
              it:`Ci dispiace che tu abbia deciso di uscire, 
                Essendo un utente registrato a reMind, riceverai ancora importanti notifiche come cambiamenti legislativi 
                o notifiche relative ai servizi che utilizzi. 
                `,
            }} /></p>
            <p style={{marginTop:"20px"}}><T obj={{
              en:`
                We hope you will continue to use our service. If you desire to get all your data deleted, please contact us. We keep the minimum necessary to not subscribe you again.`,
              it:`
                Ti invitiamo a contattarci nel caso desideri cancellare tutti i tuoi dati. Manteniamo il minimo necessario per non ricontattarti.`,
            }} /></p>
          </VisDiv>
          <VisDiv rules={[!user, prospectData ]}>
            <VisDiv style={{marginBottom:"20px"}} rules={[prospectData?.firstName]}>
              <h3>
                <T obj={{en:"Hi", it:"Ciao"}}/>
                 {` ${prospectData?.firstName ? prospectData.firstName : email}`}
              </h3>
            </VisDiv> 
            <p><T obj={{
              en:"wow",
              it:"ita",
            }} /></p>
          </VisDiv>
          <VisDiv style={{marginTop:"20px"}}>
            <BlueButton fn={unsubscribe} hide={hideTestButtons} text={<T obj={{en:"Unsubscribe", it:"Disiscriviti"}}/>} />
          </VisDiv>
      </div>
    </div>
  )
}

export default Unsubscribe
